import React, { useEffect, useState } from 'react';
import api from '../api/axiosConfig';
import { NOVEDADES_SEEN_KEY } from '../components/Navbar';
import './NovedadesPage.css';

export default function NovedadesPage() {
  const [novedades, setNovedades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get('novedades/')
      .then((r) => {
        setNovedades(r.data);
        if (r.data.length > 0) {
          try { localStorage.setItem(NOVEDADES_SEEN_KEY, r.data[0].hash); } catch { /* ignore */ }
        }
      })
      .catch(() => setStatus({ type: 'error', text: 'No se pudieron cargar las novedades.' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="novedades-root">
      <h1 className="novedades-title">📰 Novedades</h1>
      <p className="novedades-subtitle">Historial de cambios y mejoras publicadas en Farmers Hub.</p>

      {status && <div className="novedades-status">{status.text}</div>}

      <div className="novedades-card">
        {loading ? (
          <div className="novedades-empty">Cargando…</div>
        ) : novedades.length === 0 ? (
          <div className="novedades-empty">Aún no hay novedades.</div>
        ) : (
          <ul className="novedades-list">
            {novedades.map((n) => (
              <li key={n.hash} className="novedades-item">
                <div className="novedades-dot" />
                <div>
                  <div className="novedades-message">{n.message}</div>
                  <div className="novedades-date">{n.date}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
